import { render, staticRenderFns } from "./search-form-admp-news.html?vue&type=template&id=a5908516&scoped=true&"
import script from "./search-form-admp-news.ts?vue&type=script&lang=ts&"
export * from "./search-form-admp-news.ts?vue&type=script&lang=ts&"
import style0 from "./search-form-admp-news.scss?vue&type=style&index=0&id=a5908516&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5908516",
  null
  
)

/* custom blocks */
import block0 from "./search-form-admp-news.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Fhome%2Fnews-list%2Fadmp-news-search-form%2Fsearch-form-admp-news.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports